// eslint-disable-next-line import/named
import { parse, type UrlWithParsedQuery } from 'url';

import { pick } from 'Lib/utils/lodashUtils';

import { HANDLER_MAPPING, UrlFields } from './constants';
import type { FilteredUrlObject } from './types';

export const parseIntent = (intent: string): FilteredUrlObject => {
  let urlObject: UrlWithParsedQuery = {
    auth: null,
    hash: null,
    host: null,
    hostname: null,
    href: '',
    path: null,
    pathname: null,
    port: null,
    protocol: null,
    query: {},
    search: null,
    slashes: false,
  };

  try {
    urlObject = parse(intent, true, true);
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return pick(urlObject, UrlFields);
};

export const getHandlerConfigFromParsedIntent = (
  urlObject: FilteredUrlObject,
  mapping = HANDLER_MAPPING
) => {
  const { host, pathname } = urlObject;
  const intentPath = [host, pathname].filter(Boolean).join('');
  const handler = mapping[intentPath];

  return handler;
};

export const isSupportedIntent = (intent: string, mapping = HANDLER_MAPPING): boolean => {
  const urlObject = parseIntent(intent);
  const { protocol } = urlObject;
  // free form redirect
  if (protocol?.startsWith('http')) {
    return true;
  }
  const handler = getHandlerConfigFromParsedIntent(urlObject, mapping);
  return !!handler;
};
